import React, { useState, useEffect } from "react";
// Components ///
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import TitleSection from "../../molecules/title-section";
import {
    Input,
    Label,
    Select,
} from "../../../shared/comfama-ui/components/form/";
import { useForm, SubmitHandler } from "react-hook-form";
import Button from "../../atoms/button/button";
import Loading from "../../atoms/loading/loading";
// Styles //
import "./verificationMpc.scss";
import checkSvg from "../../../../src/assets/images/icons/check.svg";
import iconoBoton from "../../../../src/assets/images/icons/flechaderecha.svg";
import arrowInput from "../../../../src/assets/images/icons/arrowiconback.svg";

// utils
import { dataMPCAportante } from "../../../services/verificacionMpc";
import documentsTrans from "./utils/transformDocuments.adapter";
import { getToken } from "../../../services/formServices";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";

type Inputs = {
    documentType: string;
    documentNumber: string;
};

const VerificationMpc = (props: ReferenciaContenido) => {
    const { descripcion } = props;
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            documentType: "",
            documentNumber: "",
        },
    });

    // const [saveInformation, setSaveInformation] = useState<any>({});
    const [dataAportante, setDataAportante] = useState<any>(null); // data aportante
    const [documents, setDocuments] = useState<any>([]);
    const [errorConsult, setErrorConsult] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [validatedContribution, setValidatedContribution] = useState<boolean | null>(null);
    const urlFosfec = process.env.URL_FORM_FOSFEC;
    const urlRequisitos = "https://www.comfama.com/servicio-de-empleo/personas/subsidio-de-desempleo/requisitos-postulacion/"
    
    const tiposDocumentos =
        props.referenciaFormularios[0].titulosFormulario[0]
            .referenciaFormulario[0].listaSelect;

    const modalSuccessData = props.referenciaPlantillaContenido[0];
    const modalUnsuccessData = props.referenciaPlantillaContenido[1];
    const modalWithoutData = props.referenciaPlantillaContenido[2];
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            setIsLoading(true); // Set loading state to true
            const token = await getToken();
            const aportante = await dataMPCAportante(
                token.data.data.id_token,
                data.documentType,
                data.documentNumber
            );
            setDataAportante(aportante.data);
        } catch (error) {
            console.log(error);
            setErrorConsult("error en la consulta");
        } finally {
            setIsLoading(false); // Set loading state to false
        }
    };

    useEffect(() => {
        if (dataAportante && dataAportante.ARRAY[0].E_MENSAJE === "Si aplica para FOSFEC")
            setValidatedContribution(true);
        else setValidatedContribution(false);

    }, [dataAportante]);

    useEffect(() => {
        setDocuments(documentsTrans(tiposDocumentos));
    }, []);

    return (
        <div className={`o-verification-mpc`}>
            <div className={`container`}>
                <div className="o-verification-mpc__container">
                    <TitleSection title={props.tituloGeneral} />
                    <p className="o-verification-mpc__paragraph">
                        {" "}
                        {props.descripcion &&
                            documentToReactComponents(
                                descripcion.json.content[0].content[0]
                            )}
                    </p>
                </div>
            </div>
            <div className={`container-form`}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="o-verification-mpc__form">
                        <div className="o-verification-mpc__form__field">
                            <Label className="o-verification-mpc__form__field__label">
                                Tipo de documento{" "}
                                <span className="o-verification-mpc__form__field__label__asterisk">
                                    *
                                </span>
                            </Label>
                            <Select
                                className="o-verification-mpc__form__field__select"
                                {...register("documentType", {
                                    required: true,
                                })}
                            >
                                <option value={""} disabled hidden>
                                    Selecciona
                                </option>
                                {documents.map((document) => (
                                    <option value={document.value}>
                                        <img src={arrowInput}/>
                                        {document.name}
                                    </option>
                                ))}
                            </Select>
                            {errors.documentType && (
                                <span className="o-verification-mpc__form__field__error">
                                    Este campo es requerido
                                </span>
                            )}
                        </div>
                        <div className="o-verification-mpc__form__field">
                            <Label className="o-verification-mpc__form__field__label">
                                {" "}
                                Número de documento{" "}
                                <span className="o-verification-mpc__form__field__label__asterisk">
                                    *
                                </span>
                            </Label>
                            <div>
                                <Input
                                    type="number"
                                    className="o-verification-mpc__form__field__input"
                                    {...register("documentNumber", {
                                        required: true,
                                    })}
                                />
                                <button
                                    type="submit"
                                    className="o-verification-mpc__form__field__inputSubmit"
                                >
                                    <img src={iconoBoton}></img>
                                </button>
                            </div>
                            {errors.documentNumber && (
                                <span className="o-verification-mpc__form__field__error">
                                    Este campo es requerido
                                </span>
                            )}
                        </div>
                    </div>
                </form>
            </div>
            {isLoading && (
                <div className="loading">
                    {" "}
                    <Loading />
                </div>
            )}
            {errorConsult === "504" && (
                <p>Oops, ocurrió un error al consultar la información.</p>
            )}

            {/* Mensaje cuando no se encontró información relacionada con el usuario. */}
            { dataAportante?.ARRAY[0].E_MENSAJE == "El documento digitado no existe" ? (
                <div className="o-verification-mpc-response">
                    <img
                        src={modalWithoutData.imagenPrincipal[0].file.url}
                        className="o-verification-mpc-response__img"
                        alt="Success"
                    ></img>
                    <div className="o-verification-mpc-response__title">
                        <h2>{modalWithoutData.tituloBanner}</h2>
                    </div>
                    <div className="o-verification-mpc-response__header">
                        <div className="headerTitlesError">
                            {contentfulRenderOptions(modalWithoutData.descripcion.json)}
                        </div>
                    </div>
                    <p className="o-verification-mpc-response__title__paragraphInitialError">
                        {modalWithoutData.tituloDescripcion}
                    </p>
                    <div className="o-verification-mpc-response__target">
                        <div className="content-target">
                            {[
                                "Estar desempleado y no estar recibiendo algún ingreso económico.",
                                "Haber realizado aportes a Cajas de Compensación Familiar.",
                                "No haber sido beneficiario del Subsidio al Desempleo en los últimos 3 años.",
                                "Estar inscrito en el Servicio Público de Empleo.",
                                "Realizar tu postulación en la última Caja de Compensación Familiar en la que estuviste afiliado."
                            ].map((item, index) => (
                                <div className="content-itemsError" key={index}>
                                <div className="content-title">
                                    <div className="content-title_icon">
                                    <img src={checkSvg} alt="Check" />
                                    </div>
                                    <h4>{item}</h4>
                                </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <p className="o-verification-mpc-response__paragraphFinal">
                        Ahora sí, comienza tu proceso de postulación.
                    </p>
                    <div className="o-verification-mpc-response__buttons">
                        <Button
                            classname="a-button primary"
                            type="link"
                            text="Regresar"
                            isDisabled={false}
                            href="./"
                        />
                        <Button
                            classname="a-button__magenta gtmDocumentoNoEncontradoPostularme"
                            type="link"
                            text="Quiero postularme"
                            isDisabled={false}
                            href={urlRequisitos}
                        />
                    </div>
                </div>
            ):( dataAportante && !validatedContribution && (
                <div className="o-verification-mpc-response">
                    <img
                        src={modalUnsuccessData.imagenPrincipal[0].file.url}
                        className="o-verification-mpc-response__img"
                        alt="Success"
                    ></img>
                    <div className="o-verification-mpc-response__title">
                        <h2>{modalUnsuccessData.tituloBanner}</h2>
                        <h3>{dataAportante?.ARRAY[0].E_NOMBRE1 + " " +
                             dataAportante?.ARRAY[0].E_NOMBRE2 + " " +
                             dataAportante?.ARRAY[0].E_APELLIDO1 + " " +
                             dataAportante?.ARRAY[0].E_APELLIDO2
                             }  </h3>
                    </div>
                    <div className="o-verification-mpc-response__header">
                        <div className="headerTitles">
                            <h4>Tiempo cotización Comfama:</h4>
                            <span>
                                {dataAportante.ARRAY[0].E_TOTAL_MESES + "  Meses"}
                            </span>
                        </div>
                        <div className="headerTitles">
                            <h4>Tipo afiliación:</h4>
                            <span>   
                                {dataAportante && dataAportante.ARRAY[0].E_MOD_POSTU}
                            </span>
                        </div>
                    </div>
                        <div className="o-verificacion-mpc-message">
                            <p className="nowrap">
                                {contentfulRenderOptions(modalUnsuccessData.descripcion.json)}
                            </p>
                        </div>
                        <p className="o-verification-mpc-response__paragraphFinal upsText">
                            {modalUnsuccessData.tituloDescripcion}
                        </p>
                    <div className="o-verification-mpc-response__buttons">
                        <Button
                            classname="a-button primary"
                            type="link"
                            text="Regresar"
                            isDisabled={false}
                            href="./"
                        />
                        <Button
                            classname="a-button__magenta gtmDocumentoNoEncontradoPostularme"
                            type="link"
                            text="Quiero postularme"
                            isDisabled={false}
                            href={urlRequisitos}
                        />
                    </div>
                </div>
            ))}

            {/* Aplica para subsidio fosfec. */}
            { validatedContribution && (
                <div className="o-verification-mpc-response">
                    <img
                        src={modalSuccessData.imagenPrincipal[0].file.url}
                        className="o-verification-mpc-response__img"
                        alt="Success"
                    ></img>
                    <div className="o-verification-mpc-response__title">
                        <h2>{modalSuccessData.tituloBanner}</h2>
                        <h3>{dataAportante?.ARRAY[0].E_NOMBRE1 + " " +
                             dataAportante?.ARRAY[0].E_NOMBRE2 + " " +
                             dataAportante?.ARRAY[0].E_APELLIDO1 + " " +
                             dataAportante?.ARRAY[0].E_APELLIDO2
                             }  </h3>
                    </div>
                    <div className="o-verification-mpc-response__header">
                        <div className="headerTitles">
                            <h4>Tiempo cotización Comfama:</h4>
                            <span>
                                {dataAportante.ARRAY[0].E_TOTAL_MESES + "  Meses"}
                            </span>
                        </div>
                        <div className="headerTitles">
                            <h4>Tipo afiliación:</h4>
                            <span>   
                                {dataAportante.ARRAY[0].E_MOD_POSTU}
                            </span>
                        </div>
                    </div>
                    <p className="o-verification-mpc-response__title__paragraphInitial">
                        {contentfulRenderOptions(modalSuccessData.descripcion.json)}
                    </p>                    
                        <div className="o-verification-mpc-response__target">
                            <div className="target-title">
                                <h4>{modalSuccessData.referenciaContenido[0].tituloBanner}</h4>
                            </div>
                            <div className="content-target">
                                <div className="content-items">
                                    <div className="content-title">
                                        <div className="content-title_icon">
                                            <img src={checkSvg} alt="Check" />
                                        </div>
                                        <p className="tarifa_clasificacion">
                                            {modalSuccessData.referenciaContenido[0].referenciaContenido[0].tituloBanner}
                                        </p>
                                        <div className="tooltip">
                                            <img
                                                className="tooltipImg"
                                                src={modalSuccessData.referenciaContenido[0].referenciaContenido[0].imagenPrincipal[0].file.url}
                                                alt="icono-info"
                                            />
                                            <span className="tooltipText">
                                                {contentfulRenderOptions(modalSuccessData.referenciaContenido[0].referenciaContenido[0].descripcion.json)}
                                            </span>
                                        </div>
                                    </div>
                                    <p className="tarifa_descripcion">
                                        {modalSuccessData.referenciaContenido[0].referenciaContenido[0].tituloDescripcion}
                                    </p>
                                </div>
                                <div className="content-items">
                                    <div className="content-title">
                                        <div className="content-title_icon">
                                            <img src={checkSvg} alt="Check"></img>
                                        </div>
                                            <p className="tarifa_clasificacion">
                                                {modalSuccessData.referenciaContenido[0].referenciaContenido[1].tituloBanner}
                                            </p>
                                            <div className="tooltip">
                                                <img
                                                    className="tooltipImg"
                                                    src={modalSuccessData.referenciaContenido[0].referenciaContenido[0].imagenPrincipal[0].file.url}
                                                    alt="icono-info"
                                                />
                                            <span className="tooltipText">
                                                {contentfulRenderOptions(modalSuccessData.referenciaContenido[0].referenciaContenido[1].descripcion.json)}
                                            </span>
                                        </div>
                                    </div>
                                    <p className="tarifa_descripcion">
                                        {modalSuccessData.referenciaContenido[0].referenciaContenido[1].tituloDescripcion}
                                    </p>
                                </div>
                            </div>
                        </div>        
                        <div className="o-verificacion-mpc-message light">
                            <p>
                                {contentfulRenderOptions(modalSuccessData.referenciaContenido[0].descripcion.json)}
                            </p>
                        </div>
                    
                    
                    <p className="o-verification-mpc-response__paragraphFinal">
                        {modalSuccessData.referenciaContenido[0].tituloDescripcion}
                    </p>
                    <div className="o-verification-mpc-response__buttons">
                        <Button
                            classname="a-button primary"
                            type="link"
                            text="Regresar"
                            isDisabled={false}
                            href="./"
                        />
                        <Button
                            classname="a-button__magenta gtmCumpleCotizaciónSubsidio"
                            type="link"
                            text="Quiero postularme"
                            isDisabled={false}
                            href={urlRequisitos}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default VerificationMpc;
